import { Directive, Input, Optional } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS, ValidationErrors, NgForm } from '@angular/forms';

@Directive({
    selector: '[datesValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: DatesValidatorDirective,
            multi: true,
        },
    ],
})
export class DatesValidatorDirective implements Validator {
    @Input('datesValidator')
    secondControlName: string;

    @Input()
    isStartDate: boolean;

    @Input()
    isEndDate: boolean;

    constructor(@Optional() private form: NgForm) {}

    validate(control: AbstractControl<any, any>): ValidationErrors {
        if (!control || !this.form || !this.secondControlName) {
            return null;
        }

        // Get the second control from the form by name
        const secondControl: AbstractControl = this.form.form?.get(this.secondControlName);
        if (!secondControl || !control.value || !secondControl.value) {
            return null;
        }

        if (this.isStartDate) {
            if (secondControl.value <= control.value) {
                return { startDateGreaterThanEndDate: true };
            } else {
                secondControl.setErrors(null);
            }
        }

        if (this.isEndDate) {
            if (secondControl.value >= control.value) {
                return { startDateGreaterThanEndDate: true };
            } else {
                secondControl.setErrors(null);
            }
        }

        return null;
    }
}
